var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    ref: "rootRef",
    class: _vm.$style.wrapper
  }, [_c(_setup.NotificationsButton, {
    attrs: {
      "has-unread-notifications": _setup.hasUnreadNotifications
    },
    on: {
      "click": _setup.toggleNotifications
    }
  }), _vm._v(" "), _setup.screen.isTabletOrDesktop ? _c(_setup.VFadeTransition, [_setup.notificationsOpen ? _c(_setup.NotificationsContent, {
    class: _vm.$style.content,
    attrs: {
      "header-height": _setup.props.headerHeight
    },
    on: {
      "close": _setup.closeNotifications
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _setup.notificationsModalOpen ? _c(_setup.ModalNotifications, {
    on: {
      "close": _setup.closeNotifications
    }
  }) : _vm._e()], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };